"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAskPropertyAgent = void 0;
exports.defaultAskPropertyAgent = {
    translate: {
        title: 'Ask a Property Agent',
        subHeader: 'Questions about Hong Kong Property & Living answered by OKAY.com agents & experts.',
        askQuestion: 'Ask A Question',
        viewQA: 'View Q&A',
    },
};
